import { render, staticRenderFns } from "./NormalHeader.vue?vue&type=template&id=04ff9c6e&"
import script from "./NormalHeader.vue?vue&type=script&lang=js&"
export * from "./NormalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports